import {PageTitle} from "../../../Components/Landmarks";
import type { ContextProps } from '../../../types';
import React, {useEffect, useState} from "react";
import {isGuidEmpty, isNullOrUndefined} from "../../../Utilities/commonUtilities";
import {OrderProcessingView} from "./OrderProcessingView";
import {OrderDetailsView} from "./OrderDetailsView";
import {orderProcessingApi} from "./orderProcessingApi";
import {libraryCatalogApi} from "../../Library/libraryCatalogApi";
import {createListFromArrayOfObjects} from "../../../Utilities/Types/listUtilities";
import type { ListItem } from "../../../Utilities/Types/listUtilities";
import {
    fulfillOrderModel,
    orderDetailsModel, placeAnOrderModel, receiveOrderModel
} from "./orderProcessingFactory";
import {LayoutFullBleed} from "../../../Components/Layout";
import {SYSTEM_TYPES} from "../../Library/libraryConstants";

export const OrderProcessingContainer = ({
                                             orderId,
                                             handleApiCall,
                                             handleReturnRedirect,
                                             redirect,
                                             setWarnings,
                                         }: ContextProps) => {

    const [orderDetails, setOrderDetails] = useState<Record<string, unknown> | null>(null);
    const [vendors, setVendors] = useState<ListItem[] | null>(null);
    const systemType = SYSTEM_TYPES.Textbooks;

    const handleReturn = () => handleReturnRedirect();

    const handlePlaceAnOrder = async (placeAnOrderDetails: Record<string, unknown>) => {
        const sanitizedModel = placeAnOrderModel(placeAnOrderDetails) as Record<string, unknown>;
        if ((orderDetails as Record<string, unknown>)?.alternateFormat !== sanitizedModel.alternateFormat)
            sanitizedModel.isAlternateFormatOrdered = true;
        handleApiCall(() => orderProcessingApi.placeAnOrder(sanitizedModel), loadOrderResult);
    };

    const handleReceiveOrder = async (receiveOrderDetails: Record<string, unknown>) => {
        const sanitizedModel = receiveOrderModel(receiveOrderDetails);
        handleApiCall(() => orderProcessingApi.receiveOrder(sanitizedModel), loadOrderResult);
    };

    const handleFulfillOrder = async (fulfillOrderDetails: Record<string, unknown>) => {
        const sanitizedModel = fulfillOrderModel(fulfillOrderDetails);
        handleApiCall(() => orderProcessingApi.fulfillOrder(sanitizedModel), loadOrderResult);
    };

    const handleRevertFromComplete = async () => {
        handleApiCall(() => orderProcessingApi.revertOrderFromComplete(orderId), loadOrderResult);
    };

    const loadOrderResult = (result: Record<string, unknown>) => {
        const od = orderDetailsModel(result) as Record<string, unknown>;
        od.numberOfVolumesReceived = null;
        od.volumesReceived = null;
        setOrderDetails(od);
    };

    useEffect(() => {
        const getOrderDetails = () => handleApiCall(() => orderProcessingApi.getOrder(orderId), loadOrderResult);
        const getVendors = () => {
            handleApiCall(() => libraryCatalogApi.getVendors(systemType),
                (results: Record<string, unknown>[]) => setVendors(createListFromArrayOfObjects(results, "vendorId", "name")));
        }
        if (orderId && !isGuidEmpty(orderId) && !orderDetails)
            getOrderDetails();
        if (!vendors)
            getVendors();
    }, [orderId, orderDetails]);

    return <>
        {!isNullOrUndefined(orderDetails) &&
            <>
                <PageTitle h1={`Process Order`}/>
                <OrderProcessingView
                    orderDetails={orderDetails}
                    vendors={vendors}
                    handleApiCall={handleApiCall}
                    handleReturn={handleReturn}
                    handlePlaceAnOrder={handlePlaceAnOrder}
                    handleFulfillOrder={handleFulfillOrder}
                    handleReceiveOrder={handleReceiveOrder}
                    handleRevertFromComplete={handleRevertFromComplete}
                    redirect={redirect}
                    setWarnings={setWarnings}
                />
                <LayoutFullBleed>
                    <OrderDetailsView orderDetails={orderDetails}/>
                </LayoutFullBleed>
            </>}
    </>;
};

